import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useLocation } from "react-router-dom";

const Services = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const controlsLeft = useAnimation();
  const controlsRight = useAnimation();
  const [refLeft, inViewLeft] = useInView({ triggerOnce: true });
  const [refRight, inViewRight] = useInView({ triggerOnce: true });

  useEffect(() => {
    if (inViewLeft) controlsLeft.start({ x: 0, opacity: 1 });
    if (inViewRight) controlsRight.start({ x: 0, opacity: 1 });
  }, [inViewLeft, inViewRight]);






  const routerLocation = useLocation(); // ✅ FIX: renamed

  useEffect(() => {
    const params = new URLSearchParams(routerLocation.search);
    const tab = params.get("tab");

    if (tab) {
      const tabId = `features-tab-${tab}`;

      // Remove active classes
      document.querySelectorAll(".tab-pane").forEach(el =>
        el.classList.remove("active", "show")
      );

      document.querySelectorAll(".nav-link").forEach(el =>
        el.classList.remove("active", "show")
      );

      // Activate tab pane
      const pane = document.getElementById(tabId);
      if (pane) pane.classList.add("active", "show");

      // Activate nav link
      const nav = document.querySelector(`[data-bs-target="#${tabId}"]`);
      if (nav) nav.classList.add("active", "show");

      // Scroll into view
      // setTimeout(() => {
      //   pane?.scrollIntoView({ behavior: "smooth" });
      // }, 200);
      setTimeout(() => {
  const yOffset = -280; // 👈 adjust: navbar height or heading 
  const y = pane.getBoundingClientRect().top + window.pageYOffset + yOffset;

  window.scrollTo({
    top: y,
    behavior: "smooth"
  });
}, 200);

    }
  }, [routerLocation]); // ✅ FIX HERE TOO

  // --- ICONS ---
  // const icons = [
  //   "assets/img/tech_icon/react.svg",
  //   "assets/img/tech_icon/bootstrap.svg",
  //   "assets/img/tech_icon/express.svg",
  //   "assets/img/tech_icon/github.svg",
  //   "assets/img/tech_icon/python-original.svg",
  //   "assets/img/tech_icon/docker.svg",
  //   "assets/img/tech_icon/git.svg",
  //   "assets/img/tech_icon/nodejs.svg",
  //   "assets/img/tech_icon/javascript.svg",
  //   "assets/img/tech_icon/Gcloud.svg",
  //   "assets/img/tech_icon/mongodb.svg",
  //   "assets/img/tech_icon/html5.svg",
  //   "assets/img/tech_icon/css3.svg",
  //    "assets/img/tech_icon/aws.svg",
  // ];

  // const outerIcons = icons.slice(0, 8);
  // const innerIcons = icons.slice(8);

  // const outerAngle = 360 / outerIcons.length;
  // const innerAngle = 360 / innerIcons.length;

  return (
    <div>
      <section
  className="section mt-5 contact-hero"
  style={{
    backgroundImage: `url('/assets/img/about-bg.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    padding: '60px 0',
    position: 'relative',
    color: '#fff',
    textAlign: 'center',
  }}
>
  {/* Overlay for fade effect */}
  <div
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)', // fade effect
      zIndex: 1,
    }}
  ></div>

  <div className="container" style={{ position: 'relative', zIndex: 2 }}>
    <div className="row justify-content-center">
      <div className="col-lg-8">
        <nav className="custom-breadcrumbs mb-3">
          <a href="/">Home</a>
          <span className="separator">/</span>
          <a href="/about">Services</a>
         
          
        </nav>
        <h1  style={{color:'#c5c5c5'}}className="display-4 fw-bold">Services</h1>
        <p className="lead mt-3">
      We provide a wide range of technology solutions designed to drive growth, efficiency, and security for your business.
        </p>
      </div>
    </div>
  </div>
</section>
      {/* services Section */}
  <section id="services" className="features section  mt-2">

  <div className="container">
    <div className="d-flex justify-content-center">
      <ul className="nav nav-tabs" data-aos="fade-up" data-aos-delay={100}>
        <li className="nav-item">
          <a className="nav-link active show" data-bs-toggle="tab" data-bs-target="#features-tab-1">
            <h4>Custom Software</h4>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" data-bs-toggle="tab"  id="Cloud-Solutions" data-bs-target="#features-tab-2">
            <h4>Cloud Solutions</h4>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" data-bs-toggle="tab" id="Mobile-Apps" data-bs-target="#features-tab-3">
            <h4>Mobile Application</h4>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" data-bs-toggle="tab" data-bs-target="#features-tab-4">
            <h4>Cybersecurity</h4>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" data-bs-toggle="tab"  id="Cloud-Solutions" data-bs-target="#features-tab-5">
            <h4>Data Analytics</h4>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" data-bs-toggle="tab" data-bs-target="#features-tab-6">
            <h4>Consultation</h4>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" data-bs-toggle="tab" data-bs-target="#features-tab-7">
            <h4>Staff Augmentation</h4>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" data-bs-toggle="tab" data-bs-target="#features-tab-8">
            <h4>AI Consulting</h4>
          </a>
        </li>
      </ul>
    </div>

    <div className="tab-content" data-aos="fade-up" data-aos-delay={200}>
      {/* Custom Software Development */}
      <div className="tab-pane fade active show" id="features-tab-1">
        <div className="row">
          <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
            <h3>Custom Software Development</h3>
<p>
  We craft software tailored to your unique business needs. From enterprise applications to specialized intelligent solutions,
  our team ensures scalable, reliable, and future-ready software to enhance operations, efficiency, and business growth. 
  Our development process focuses on clear communication, cutting-edge technology, and delivering real measurable results.
</p>

<ul>
  <li><i className="bi bi-check2-all"></i> End-to-end software lifecycle support (Planning to Deployment)</li>
  <li><i className="bi bi-check2-all"></i> Cross-platform and scalable architecture with modern tech stacks</li>
  <li><i className="bi bi-check2-all"></i> API-driven, cloud-ready, and performance-optimized solutions</li>
  <li><i className="bi bi-check2-all"></i> Agile development approach with transparent progress tracking</li>
  <li><i className="bi bi-check2-all"></i> UX-focused design for high adoption and engagement</li>
  <li><i className="bi bi-check2-all"></i> Continuous maintenance, upgrades, and long-term technical support</li>
</ul>
</div>
          <div className="col-lg-6 order-1 order-lg-2 text-center">
            <img src="assets/Service_1.png"   alt="Custom Software" className="img-fluid " />
          </div>
        </div>
      </div>

    {/* Cloud Solutions */}
<div className="tab-pane fade" id="features-tab-2">
  <div className="row">
    <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
      <h3>Scalable Cloud Solutions</h3>
      <p>
        Harness the full potential of the cloud to increase agility, reduce operational costs, and ensure high availability.
        Our cloud services help businesses modernize legacy systems, integrate secure infrastructure, automate processes,
        and enhance performance with unmatched scalability. Whether you're starting cloud adoption or optimizing an existing setup,
        we design architectures that support growth, resilience, and seamless digital transformation.
      </p>
     
      <ul>
  <li><i className="bi bi-check2-all" /> Cloud migration & infrastructure optimization</li>
  <li><i className="bi bi-check2-all" /> Hybrid & multi-cloud deployment strategies</li>
  <li><i className="bi bi-check2-all" /> High availability, security protocols & disaster recovery planning</li>
  <li><i className="bi bi-check2-all" /> Serverless architecture & microservices implementation</li>
  <li><i className="bi bi-check2-all" /> Cost optimization, monitoring & performance tuning</li>
  <li><i className="bi bi-check2-all" /> Continuous integration & automated cloud workflows</li>
</ul>

    </div>
    <div className="col-lg-6 order-1 order-lg-2 text-center">
      <img src="assets/Service_3.png" alt="Cloud Solutions" className="img-fluid " />
    </div>
  </div>
</div>

{/* Mobile Apps */}
<div className="tab-pane fade" id="features-tab-3">
  <div className="row">
    <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
      <h3>Mobile App Development</h3>
      <p>
        We build high-performance, user-centric mobile applications for Android and iOS that deliver seamless experiences.
        Our mobile solutions are designed to increase user engagement, modernize workflows, automate processes,
        and elevate your digital presence.Whether it's an enterprise app, eCommerce platform, or a startup MVP, we ensure smooth performance, secure architecture,
        and scalable development to support future enhancements and user demands.
      </p>
    
      <ul>
  <li><i className="bi bi-check2-all" /> Native, hybrid & cross-platform development</li>
  <li><i className="bi bi-check2-all" /> Human-centered UI/UX design with strong usability focus</li>
  <li><i className="bi bi-check2-all" /> Testing, deployment, scaling & post-launch maintenance</li>
  <li><i className="bi bi-check2-all" /> App store optimization (ASO) & compliance-ready publishing</li>
  <li><i className="bi bi-check2-all" /> Integration with cloud services, APIs, sensors & IoT systems</li>
  <li><i className="bi bi-check2-all" /> Real-time analytics, security features & performance monitoring</li>
</ul>

    </div>
    <div className="col-lg-6 order-1 order-lg-2 text-center">
      <img src="assets/Service_4.png"  alt="Mobile App" className="img-fluid " />
    </div>
  </div>
</div>

{/* Cybersecurity Solutions */}
<div className="tab-pane fade" id="features-tab-4">
  <div className="row">
    <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
      <h3>Cybersecurity Solutions</h3>
      <p>
        Protect your digital assets with cutting-edge cybersecurity solutions designed to safeguard against internal and external threats.
        We help businesses strengthen their security posture with continuous monitoring, threat intelligence,
        and compliance-driven strategies. From vulnerability management to secure infrastructure design, we ensure your systems remain protected and resilient
        across evolving cyber risks.
      </p>
    <ul>
  <li><i className="bi bi-check2-all" /> Real-time threat detection, monitoring & incident response</li>
  <li><i className="bi bi-check2-all" /> Data encryption, access control & secure communications</li>
  <li><i className="bi bi-check2-all" /> Compliance with ISO, GDPR, HIPAA, and industry standards</li>
  <li><i className="bi bi-check2-all" /> Security audits, penetration testing & risk assessments</li>
  <li><i className="bi bi-check2-all" /> Zero-trust architecture implementation & identity verification</li>
  <li><i className="bi bi-check2-all" /> Continuous monitoring, vulnerability management & cyber hygiene training</li>
</ul>

    </div>
    <div className="col-lg-6 order-1 order-lg-2 text-center">
      <img src="assets/Service_5.png"  alt="Cybersecurity" className="img-fluid " />
    </div>
  </div>
</div>

{/* Data Analytics */}
<div className="tab-pane fade" id="features-tab-5">
  <div className="row">
    <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
      <h3>Data Analytics</h3>
      <p>
        Unlock hidden opportunities with advanced data analytics solutions that convert complex datasets into actionable intelligence.
        We empower organizations to make smarter decisions, enhance business forecasting, optimize operations,
        and increase revenue with predictive insights.With automated dashboards, machine learning models, and real-time analytics, we help you understand trends,
        customer behavior, and performance metrics more clearly than ever before.
      </p>
    
      <ul>
  <li><i className="bi bi-check2-all"></i> Data collection, preprocessing, and intelligent data modeling</li>
  <li><i className="bi bi-check2-all"></i> Predictive analytics, AI-driven recommendations & forecasting</li>
  <li><i className="bi bi-check2-all"></i> Dashboards, BI tools & interactive visual reporting</li>
  <li><i className="bi bi-check2-all"></i> Statistical analysis, pattern recognition & trend insights</li>
  <li><i className="bi bi-check2-all"></i> Integration with CRM, ERP, cloud platforms & data pipelines</li>
  <li><i className="bi bi-check2-all"></i> KPI tracking, performance measurement & decision support systems</li>
</ul>

    </div>
    <div className="col-lg-6 order-1 order-lg-2 text-center">
      <img src="assets/Service_6.png"  alt="Consultation" className="img-fluid " />
    </div>
  </div>
</div>

{/* Strategic Consultation */}
<div className="tab-pane fade" id="features-tab-6">
  <div className="row">
    <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
      <h3>Consultation</h3>
      <p>
        Make confident technology decisions with expert strategic consulting that aligns innovation with business goals.
        We help organizations assess their current processes, identify technology gaps, and build actionable digital roadmaps
        to accelerate growth and maximize ROI. Our consulting approach focuses on modernization, process refinement, cost optimization,
        and digital transformation guided by future-ready strategies.
      </p>
    
      <ul>
  <li><i className="bi bi-check2-all" /> Technology roadmap design & transformation strategy</li>
  <li><i className="bi bi-check2-all" /> Business workflow analysis & process automation advisory</li>
  <li><i className="bi bi-check2-all" /> IT adoption planning, evaluation & value-driven recommendations</li>
  <li><i className="bi bi-check2-all" /> Digital maturity assessment & modernization consulting</li>
  <li><i className="bi bi-check2-all" /> Change management support & enterprise technology scaling</li>
  <li><i className="bi bi-check2-all" /> Vendor selection, platform evaluation & cost optimization guidance</li>
</ul>

    </div>
    <div className="col-lg-6 order-1 order-lg-2 text-center">
      <img src="assets/Service_2.png" alt="Consultation" className="img-fluid " />
    </div>
  </div>
</div>

{/* Staff Augmentation */}
<div className="tab-pane fade" id="features-tab-7">
  <div className="row">
    <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
      <h3>Staff Augmentation</h3>
      <p>
        Expand your team with top-tier technical talent—exactly when you need it.
        Our staff augmentation services help businesses stay agile, accelerate delivery timelines,
        and access specialized skills without the overhead of full-time hiring.   
        From short-term roles to long-term technical extensions, our experts integrate seamlessly with your existing teams,
        tools, and workflows to ensure continuity and smooth collaboration.
      </p>
    
      <ul>
  <li><i className="bi bi-check2-all" /> Access to vetted, skilled & domain-specific tech talent</li>
  <li><i className="bi bi-check2-all" /> Flexible team scaling based on workload & project timeline</li>
  <li><i className="bi bi-check2-all" /> Smooth integration with existing teams & agile processes</li>
  <li><i className="bi bi-check2-all" /> Dedicated support for short-term, long-term & project-based roles</li>
  <li><i className="bi bi-check2-all" /> Transparent communication, performance tracking & delivery assurance</li>
  <li><i className="bi bi-check2-all" /> Global remote talent availability with timezone-aligned collaboration</li>
</ul>

    </div>
    <div className="col-lg-6 order-1 order-lg-2 text-center">
      <img src="assets/Service_7.png" alt="Staff Augmentation" className="img-fluid" />
    </div>
  </div>
</div>


<div className="tab-pane fade" id="features-tab-8">
  <div className="row">
    <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
      <h3>AI Consulting</h3>
      <p>
        Harness the power of artificial intelligence to transform your business operations and unlock new growth 
        opportunities. Our AI consulting services help organizations identify the right AI use cases, implement 
        intelligent solutions, and integrate advanced technologies into their existing systems. From strategy to 
        deployment, we guide businesses through every stage of their AI journey to drive efficiency, innovation, 
        and data-driven decision making.
      </p>
      <ul>
        <li><i className="bi bi-check2-all" />AI strategy development aligned with your business goals</li>
        <li><i className="bi bi-check2-all" />Identification of high-impact AI and automation opportunities</li>
        <li><i className="bi bi-check2-all" />Custom AI and machine learning solution development</li>
        <li><i className="bi bi-check2-all" />Integration of AI models with existing systems and workflows</li>
        <li><i className="bi bi-check2-all" />Data analysis, predictive insights & intelligent automation</li>
        <li><i className="bi bi-check2-all" />Ongoing support, optimization & performance monitoring</li>
  
</ul>

    </div>
    <div className="col-lg-6 order-1 order-lg-2 text-center">
      <img src="assets/Service_8.png" alt="Staff Augmentation" className="img-fluid" />
    </div>
  </div>
</div>




    </div>
  </div>
</section>

    {/* /services Section */}
      <section className="service-lifecycle-wrapper"  id="services-lifecycle">
        <h2 className="service-lifecycle-title">
          Empowering Businesses Through Smart IT Lifecycle Solutions
        </h2>
        <p className="service-lifecycle-subtitle">
          From strategy to sustainability — we optimize every stage of your digital transformation journey.
        </p>

        <div className="service-lifecycle-content">
          {/* Left Section */}
          <motion.div
            ref={refLeft}
            initial={{ x: -150, opacity: 0 }}
            animate={controlsLeft}
            transition={{ duration: 1 }}
            className="service-lifecycle-left"
          >
            <div className="service-card consult-card">
              <h3>Consulting</h3>
              <p>Strategic IT consultation for scalable, secure, and innovative cloud-driven solutions.</p>
            </div>

            <div className="service-card optimize-card">
              <h3>Optimization</h3>
              <p>Maximize efficiency and performance with AI-driven analytics and automation.</p>
            </div>
          </motion.div>

          {/* Center Rotating Orbit */}
          <div className="service-lifecycle-center">

            {/* OUTER */}
          <div className="outer-orbit">

            <div className="orbit-item" style={{ transform: `rotate(0deg) translate(var(--outer-radius)) rotate(0deg)` }}>
                 <img src="assets/img/tech_icon/react.svg" />
            </div>

            <div className="orbit-item" style={{ transform: `rotate(45deg) translate(var(--outer-radius)) rotate(-45deg)` }}>
               <img src="assets/img/tech_icon/bootstrap.svg" />
            </div>

            <div className="orbit-item" style={{ transform: `rotate(90deg) translate(var(--outer-radius)) rotate(-90deg)` }}>
              <img src="assets/img/tech_icon/express.svg" />
            </div>

            <div className="orbit-item" style={{ transform: `rotate(135deg) translate(var(--outer-radius)) rotate(-135deg)` }}>
             <img src="assets/img/tech_icon/github.svg" />
            </div>

            <div className="orbit-item" style={{ transform: `rotate(180deg) translate(var(--outer-radius)) rotate(-180deg)` }}>
              <img src="assets/img/tech_icon/python-original.svg" />
            </div>

            <div className="orbit-item" style={{ transform: `rotate(225deg) translate(var(--outer-radius)) rotate(-225deg)` }}>
              <img src="assets/img/tech_icon/docker.svg" />
            </div>

            <div className="orbit-item" style={{ transform: `rotate(270deg) translate(var(--outer-radius)) rotate(-270deg)` }}>
              <img src="assets/img/tech_icon/git.svg" />
            </div>

            <div className="orbit-item" style={{ transform: `rotate(315deg) translate(var(--outer-radius)) rotate(-315deg)` }}>
              <img src="assets/img/tech_icon/nodejs.svg" />
            </div>

          </div>


  {/* INNER */}
  <div className="inner-orbit">

    <div className="orbit-item" style={{ transform: `rotate(0deg) translate(var(--inner-radius)) rotate(0deg)` }}>
      <img src="assets/img/tech_icon/javascript.svg" />
    </div>

    <div className="orbit-item" style={{ transform: `rotate(60deg) translate(var(--inner-radius)) rotate(-60deg)` }}>
      <img src="assets/img/tech_icon/Gcloud.svg" />
    </div>

    <div className="orbit-item" style={{ transform: `rotate(120deg) translate(var(--inner-radius)) rotate(-120deg)` }}>
      <img src="assets/img/tech_icon/mongodb.svg" />
    </div>

    <div className="orbit-item" style={{ transform: `rotate(180deg) translate(var(--inner-radius)) rotate(-180deg)` }}>
      <img src="assets/img/tech_icon/html5.svg" />
    </div>

    <div className="orbit-item" style={{ transform: `rotate(240deg) translate(var(--inner-radius)) rotate(-240deg)` }}>
      <img src="assets/img/tech_icon/css3.svg" />
    </div>

    <div className="orbit-item" style={{ transform: `rotate(300deg) translate(var(--inner-radius)) rotate(-300deg)` }}>
      <img src="assets/img/tech_icon/aws.svg" />
    </div>

  </div>

  <div className="circle-center">
    <h4>TechSphere™ Services</h4>
  </div>

            </div>

          {/* Right Section */}
          <motion.div
            ref={refRight}
            initial={{ x: 150, opacity: 0 }}
            animate={controlsRight}
            transition={{ duration: 1 }}
            className="service-lifecycle-right"
          >
            <div className="service-card implement-card">
              <h3>Implementation</h3>
              <p>Fast, reliable, and secure deployment with CI/CD, zero downtime, and scalability in mind.</p>
            </div>

            <div className="service-card lifecycle-card">
              <h3>Lifecycle</h3>
              <p>Comprehensive support for system upgrades, monitoring, and continuous innovation.</p>
            </div>
          </motion.div>

        </div>
        

      </section>

      {/* CSS Styling */}
      <style>{`
        .service-lifecycle-wrapper {
          background: #fafafa;
          padding: 80px 5%;
          text-align: center;
        }

        .service-lifecycle-title {
          font-size: 2.2rem;
          font-weight: 700;
          color: #222;
          margin-bottom: 10px;
        }

        .service-lifecycle-subtitle {
          color: #555;
          font-size: 1.1rem;
          margin-bottom: 60px;
        }

        .service-lifecycle-content {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          gap: 140px;
        }

        .service-lifecycle-left,
        .service-lifecycle-right {
          width: 300px;
          display: flex;
          flex-direction: column;
          gap: 60px;
        }

        .service-card {
          background: #fff;
          border-radius: 16px;
          padding: 25px;
          box-shadow: 0 5px 20px rgba(0,0,0,0.1);
          transition: transform 0.3s ease;
          text-align: left;
        }

        .service-card:hover {
          transform: translateY(-10px);
        }

        /* --- ORBIT STYLES --- */
        .service-lifecycle-center {
          position: relative;
          width: 320px;
          height: 320px;
        }

        .outer-orbit, .inner-orbit {
          position: absolute;
          top: 50%;
          left: 50%;
          border-radius: 50%;
          border: 4px dotted #007bff;
          transform: translate(-50%, -50%);
          animation: rotateOrbit 20s linear infinite;
        }

        .outer-orbit {
          width: 480px;
          height: 480px;
          animation-direction: normal;
        }

        .inner-orbit {
          width: 280px;
          height: 280px;
          animation-direction: reverse;
        }

        @keyframes rotateOrbit {
          from { transform: translate(-50%, -50%) rotate(0deg); }
          to { transform: translate(-50%, -50%) rotate(360deg); }
        }

        .orbit-item {
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.orbit-item img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: transform 0.3s ease;
}


        .orbit-item img:hover {
          transform: scale(1.3);
        }

        .circle-center {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 160px;
          height: 160px;
          background: linear-gradient(135deg, #007bff, #00c6ff);
          border-radius: 50%;
          transform: translate(-50%, -50%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-weight: bold;
          text-align: center;
          box-shadow: 0 4px 25px rgba(0,0,0,0.2);
        }

        @media (max-width: 900px) {
          .service-lifecycle-content {
            flex-direction: column;
            gap: 80px;
          }
        }

@media (max-width: 1366px) {
  .service-lifecycle-content {
    gap: 100px;
  }
  .outer-orbit { width: 420px; height: 420px; }
  .inner-orbit { width: 250px; height: 250px; }
}

@media (max-width: 1024px) {
  .service-lifecycle-content {
    flex-direction: column;
    gap: 100px;
  }

  .service-lifecycle-left,
  .service-lifecycle-right {
    width: 90%;
    gap: 40px;
  }

  .service-lifecycle-title {
    font-size: 2rem;
  }

  .outer-orbit { width: 350px; height: 350px; }
  .inner-orbit { width: 220px; height: 220px; }
  .circle-center { width: 130px; height: 130px; }
}

@media (max-width: 600px) {
  .service-lifecycle-wrapper {
    padding: 40px 3%;
  }

  .service-lifecycle-title {
    font-size: 1.6rem;
  }

  .service-lifecycle-subtitle {
    font-size: 0.95rem;
    margin-bottom: 40px;
  }

  .service-lifecycle-content {
    flex-direction: column;
    gap: 60px;
  }

  .service-lifecycle-left,
  .service-lifecycle-right {
    width: 100%;
    gap: 30px;
  }

  .service-card {
    padding: 18px;
  }

  .service-lifecycle-center {
    width: 250px;
    height: 250px;
  }

  .outer-orbit {
    width: 280px;
    height: 280px;
  }

  .inner-orbit {
    width: 160px;
    height: 160px;
  }

  .orbit-item img {
    width: 35px;
    height: 35px;
  }

  .circle-center {
    width: 100px;
    height: 100px;
    font-size: 0.8rem;
      }
    
      }
:root {
  --outer-radius: 240px;
  --inner-radius: 140px;
}

@media (max-width: 1024px) {
  :root {
    --outer-radius: 180px;
    --inner-radius: 120px;
  }
}

/* Mobile */
@media (max-width: 600px) {
  :root {
    --outer-radius: 130px;
    --inner-radius: 90px;
  }
}

      `}</style>
    </div>
  );
};

export default Services;
